<template>
  <fieldset>
    <div class="row">
      <div class="col-md-12 p-4">
        <div class="row">
          <div class="col-md-3">
            <label for="name">Name</label>
            <input
              id="name"
              type="text"
              v-model="$parent.extra.name"
            />
          </div>
          <div class="col-md-2">
            <label for="price">Price</label>
            <input
              title="price"
              id="price"
              type="number"
              placeholder="0.00"
              min="0"
              step="0.01"
              v-model="$parent.extra.price"
            />
          </div>
          <div class="col-md-2">
            <label for="cost">Cost</label>
            <input
              title="cost"
              id="cost"
              type="number"
              placeholder="0.00"
              min="0"
              step="0.01"
              v-model="$parent.extra.cost"
            />
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-6">
                <label for="stop-sell">Commissionable</label>
                <label class="switch">
                  <input id="stop-sell" name="stop_sell" type="checkbox" v-model="$parent.extra.commissionable">
                  <span class="switch__slider"></span>
                </label>
              </div>
              <div class="col-md-6">
                <label for="tour_id">Commission Rate</label>
                <input 
                  title="commission_rate"
                  type="text"
                  id="tour_id"
                  placeholder=""
                  v-model="$parent.extra.commission_rate"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <label for="tour_id">Tour ID</label>
                <!-- <select v-model="$parent.extra.tour_id">
                  <option v-for="tour in tours" :value="tour.id" :key="tour.id">{{ tour.name }}</option>
                </select> -->
                <v-select
                    v-model="$parent.selectedTours"
                    :options="this.tours"
                    label="name"
                    id="tours"
                    index="id"
                    multiple
                    placeholder="Select Tour(s)"
                  />
              </div>
              <div class="col-md-6">
                <label for="tour_id">Airlines</label>
                  <v-select
                    v-model="$parent.selectedAirlines"
                    :options="this.airlines"
                    label="name"
                    id="airline"
                    index="id"
                    multiple
                    placeholder="Select Airline(s)"
                  />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <label>Booking Date Range</label>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-md-6">
                <dateTimePicker
                  no-label
                  label="From Date"
                  id="booking-start-date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  v-model="$parent.extra.booking_start_date"
                  style="border: 1px solid #DFE5F9"
                />
              </div>
              <div class="col-md-6">
                <dateTimePicker
                    no-label
                    label="To Date"
                    id="booking-end-date"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    :only-date="true"
                    button-color="#ec391e"
                    color="#ec391e"
                    v-model="$parent.extra.booking_end_date"
                    style="border: 1px solid #DFE5F9"
                  />
              </div>
            </div>
          </div>
          
        </div>
        <div class="row mt-3">
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <label>Departure Date Range</label>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-md-6">
                <dateTimePicker
                  no-label
                  label="From Date"
                  id="booking-start-date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  v-model="$parent.extra.start_date"
                  style="border: 1px solid #DFE5F9"
                />
              </div>
              <div class="col-md-6">
                <dateTimePicker
                    no-label
                    label="To Date"
                    id="booking-end-date"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    :only-date="true"
                    button-color="#ec391e"
                    color="#ec391e"
                    v-model="$parent.extra.end_date"
                    style="border: 1px solid #DFE5F9"
                  />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <label for="short_descrtion">Short Description</label>
            <textarea id="short_descrtion" style="max-width: 100%; min-height: 8rem" v-model="$parent.extra.short_description"></textarea>
          </div>
          <div class="col-md-2">
            <label for="show_only_admin">Show only for admin ?</label>
            <label class="switch">
              <input id="show_only_admin" name="for_admin" type="checkbox" v-model="$parent.extra.for_admin">
              <span class="switch__slider"></span>
            </label>
          </div>
          <div class="col-md-2">
            <label for="apply_per_person"> Apply per person ? </label>
            <label class="switch">
              <input id="apply_per_person" name="for_per_person" type="checkbox" v-model="$parent.extra.for_per_person">
              <span class="switch__slider"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>

import axios from 'axios';
export default {
  name: 'ExtraFields',
  data () {
    return {
      tours: [],
      airlines:[],
    }
  },
  methods:{
    getTours()
    {
      axios.get(this.$api + 'tours')
      .then((response) => {
        this.tours = response.data.data
      });
    },
    getAirlines(){
      axios.get(this.$api + 'airlines',{
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then((response) => {
        this.airlines = response.data.data
      });
      
    }
  },
  mounted(){
    this.getTours()
    this.getAirlines()
  },
}
</script>
